import { InjectionToken } from "@angular/core";
import { LegalRepresentativesPort } from "./legal-representatives.port";

export const LEGAL_REPRESENTATIVES_PORT =
  new InjectionToken<LegalRepresentativesPort>("LEGAL_REPRESENTATIVES_PORT");
